import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormControl } from '@mui/material';
import styles from '../index.module.scss';
import useIntakeBlockToggle, {
  intakeBlocksEnum,
} from '../../../../hooks/useIntakeBlockToggle';
import SwitchControlField from '../../../../../../../Inputs/SwitchField/SwitchControlField';

const StartRtmBlock = () => {
  const { getValues, control } = useFormContext();

  const { isOn } = useIntakeBlockToggle();

  if (!isOn(intakeBlocksEnum.startRtm)) {
    return null;
  }

  return (
    <FormControl>
      <SwitchControlField
        control={control}
        name="setRtm"
        defaultValue={getValues('setRtm') ?? false}
        label="RTM"
        explanationText="When turned on, OneStep will generate RTM reports, whether or not this patient is eligible for RTM. For eligibility, the patient must be in Skilled Therapy and under the right coverage."
        classes={{
          root: styles.switchFieldRoot,
          label: styles.switchFieldLabel,
          explanationText: styles.explanationText,
        }}
      />
    </FormControl>
  );
};
export default StartRtmBlock;
